<template>
    <div>
        <template v-if="add_test_screen">
            <div class="row gutter-sm">
                <div class="col-xs-12 col-sm-12">
                    <q-field :count="256">
                        <q-input v-model="title" :float-label="$t('title')" :count="10" :error="$v.title.$error" @input="$v.title.$touch" />
                    </q-field>
                </div>
            </div>
            <q-table
                :data="questions"
                :columns="columns_questions"
                :pagination.sync="server_pagination"
                @request="request_questions"
                :loading="loading"
                row-key="id"
                :no-data-label="$t('no_data_avaliable')"
                :no-results-label="$t('no_results_found')"
                :loading-label="$t('loading_data')"
                :rows-per-page-label="$t('items_per_page')"
                :rows-per-page-options="[0]"
                binary-state-sort
                class="q-mt-lg"
                >
                <template slot="top" slot-scope="props">
                    <div class="q-table-title">{{ $t('questions') }}</div>
                    <div class="col" />
                    <q-btn color="primary" icon="fas fa-plus" :label="$t('add_from_model')" @click="add_model = true" class="q-mr-md" v-if="!id_test" />
                    <q-btn color="secondary" icon="fas fa-plus" :label="$t('new')" @click="showQuestion(0)" />
                </template>

                <q-tr slot="header" slot-scope="props" :props="props">
                    <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                    </q-th>
                </q-tr>

                <q-tr slot="body" slot-scope="props" :props="props">
                    <q-td auto-width key="id" :props="props">
                        {{ props.row.id }}
                    </q-td>

                    <q-td key="title" :props="props">
                        {{ props.row.title }}
                    </q-td>

                    <q-td key="webcast_evaluation_question_type" :props="props">
                        {{ getEvaluationType(props.row.webcast_evaluation_question_type) }}
                    </q-td>

                    <q-td auto-width key="actions" :props="props">
                        <q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="showQuestion(props.row.actions)" >
                            <q-tooltip>
                                {{ $t('view_or_edit_tooltip') }}
                            </q-tooltip>
                        </q-btn>

                        <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" >
                            <q-tooltip>
                                {{ $t('delete_tooltip') }}
                            </q-tooltip>
                        </q-btn>
                    </q-td>
                </q-tr>
            </q-table>

            <div class="row gutter-sm q-mt-md">
                <div class="col-xs-12 col-sm-4">
                    <p class="caption">{{ $t('status') }}</p>
                    <q-btn-toggle v-model="status" :toggle-color="getColorStatusButton" :options="statuses" />
                </div>
            </div>

            <div class="row gutter-sm justify-end q-mt-lg">
                <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                    <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="returnToTests()" />
                </div>

                <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                    <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveTest('save_test')" />
                </div>
            </div>
        </template>

        <new-question :id_webcast="id_webcast" :id_test="id_test" :id_question="id_question" :add_question="add_question" :test_types="test_types" @returnToQuestions="returnToQuestions()" />

        <new-question-model :id_webcast="id_webcast" :add_model="add_model" :model_types="model_types" :test_types="test_types" @returnToQuestionsFromModel="returnToQuestionsFromModel" />

        <q-dialog v-model="confirm_remove" @ok="removeModule()">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeModule()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue, maxLength} from 'vuelidate/lib/validators'
import NewQuestion from 'components/admin/webcasts/ReactionTestsNewQuestion'
import NewQuestionModel from 'components/admin/webcasts/ReactionTestsNewQuestionModel'

export default {
    props: ['add_test_screen', 'id_webcast', 'id_test', 'test_types', 'model_types'],

    i18nOptions: { namespaces: [ 'custom', 'common', 'training', 'admin'] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            loading: false,
            title: '',
            status: 2,
            statuses: [
                { label: this.$t('published_f'), value: 1 },
                { label: this.$t('unpublished_f'), value: 2 }
            ],
            questions: [],
            columns_questions: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'question',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'webcast_evaluation_question_type',
                    required: true,
                    label: 'question_type',
                    align: 'left',
                    field: 'webcast_evaluation_question_type',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'actions',
                    sortable: true,
                }
            ],
            id_question: '',
            add_question: false,
            add_model: false,
            action_id: '',
            confirm_remove: false
        }
    },

    components: {
        'new-question': NewQuestion,
        'new-question-model': NewQuestionModel
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getColorStatusButton() {
            if (this.status == true) return 'positive'
            else return 'negative'
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        request_questions ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination
            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''
            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }
            this.$axios.get(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/webcast_evaluation_questions/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.questions = []

                response.data.forEach(result => {
                    this.questions.push({
                        id: result.id,
                        title: result.title,
                        webcast_evaluation_question_type: result.webcast_evaluation_question_type,
                        actions: result.id
                    })
                })
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        loadTest() {
            if (this.id_test != 0) {
                this.$q.loading.show()

                this.$axios.get(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.qty_questions = response.data.qty_questions
                    this.status = response.data.status

                    this.$q.loading.hide()
                    this.request_questions({ pagination: this.server_pagination })
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else {
                this.questions = []
                this.title = ''
                this.qty_user_results = ''
                this.status = 2
            }
        },

        showQuestion(id) {
            this.$v.$touch()
            this.id_question = id

            if (!this.$v.$error) {
                this.saveTest('add_question')
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        saveTest(type) {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    'title': this.title,
                    'status': this.status
                }

                if (this.id_test != 0) {
                    this.$axios.put(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$v.$reset()

                        this.$q.notify({
                            message: this.$t('reaction_edit_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        if (type == 'add_question') {
                            this.add_question = true
                        }
                        else {
                            this.returnToTests()
                        }
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('reaction_edit_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })

                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$v.$reset()

                        this.$q.notify({
                            message: this.$t('reaction_add_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$emit('changeIdTest', response.data.id)

                        if (type == 'add_question') {
                            this.add_question = true
                        }
                        else {
                            this.returnToTests()
                        }
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('reaction_add_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeModule() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/webcast_evaluation_questions/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request_questions({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getEvaluationType(id) {
            let obj = this.test_types.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        returnToTests() {
            this.title = ''
            this.status = 2
            this.questions = []
            this.$v.$reset()

            this.$emit('returnToTests', '')
        },

        returnToQuestions() {
            window.scrollTo(0,0)

            this.request_questions({
                pagination: this.server_pagination
            })

            this.id_question = ''
            this.add_question = false
        },

        returnToQuestionsFromModel(data) {
            window.scrollTo(0,0)

            if (data.type == 'save') {
                this.$emit('changeIdTest', data.id)
            }

            this.add_model = false
        }
    },

    watch: {
        id_test: function() {
            if (this.id_test != 0) this.loadTest()
        }
    },

    created() {

    },

    validations() {
        return {
            title: { required,  maxLength: maxLength(256), },
        }
    }
}
</script>

<style>

</style>
